export const QA_NAME_ENTITY_TAB_ATTRIBUTES = 'entityTabAttributes'
